import FormElementBehaviourDropdown, { getFormElementBehaviourLabel } from "components/dropdowns/reactselect/FormElementBehaviourDropdown";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";

export const formElementsSection = (
  webformFormState: WebformFormState,
): FormSection => ({
  key: "formElements",
  title: RESX.Webform.FormElements,
  type: "collapsable",
  fields: [{
    key: "nameOfEvent",
    label: RESX.Show.NameOfEvent,
    render: () => <>{getFormElementBehaviourLabel(webformFormState.nameOfEvent)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <FormElementBehaviourDropdown
        options={[]}
        value={value}
        onChange={(value) => {
          onChange(value, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.nameOfEvent,
      submitChange: async (nameOfEvent: server.dto.FormElementBehaviors) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        eventName: nameOfEvent,
      }),
    },
  }, {
    key: "timeOfPerformance",
    label: RESX.Show.TimeOfPerformance,
    render: () => <>{getFormElementBehaviourLabel(webformFormState.timeOfPerformance)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <FormElementBehaviourDropdown
        options={[]}
        value={value}
        onChange={(value) => {
          onChange(value, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.timeOfPerformance,
      submitChange: async (timeOfPerformance: server.dto.FormElementBehaviors) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        eventTimeOfPerformance: timeOfPerformance,
      }),
    },
  }, {
    key: "eventWebsite",
    label: RESX.Show.EventWebsite,
    render: () => <>{getFormElementBehaviourLabel(webformFormState.eventWebsite)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <FormElementBehaviourDropdown
        options={[]}
        value={value}
        onChange={(value) => {
          onChange(value, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.eventWebsite,
      submitChange: async (eventWebsite: server.dto.FormElementBehaviors) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        eventWebsite,
      }),
    },
  }, {
    key: "ticketPrice",
    label: RESX.Ticket.TicketPrice,
    render: () => <>{getFormElementBehaviourLabel(webformFormState.ticketPrice)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <FormElementBehaviourDropdown
        options={[]}
        value={value}
        onChange={(value) => {
          onChange(value, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.ticketPrice,
      submitChange: async (ticketPrice: server.dto.FormElementBehaviors) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        ticketPrice,
      }),
    },
  }]
})